import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ActionSheetController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
import { AssetProvider } from '../../providers/asset/asset';
import { Asset } from '../../interfaces/asset.model';
import { Favorite } from '../../interfaces/favorite.model';

@IonicPage()
@Component({
  selector: 'page-favorites',
  templateUrl: 'favorites.html',
})
export class FavoritesPage {

  assets: Asset[];
  favorites: Favorite[];
  currentFavoriteId: number;
  filterType: string;
  radioFolderArr: any[];
  selectMode: boolean;
  selectedAssets: Asset[];
  displayAsList: boolean;

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams, 
    public translate: TranslateService, 
    public assetService: AssetProvider,
    public alertCtrl: AlertController,
    public actionSheetCtrl: ActionSheetController,
    public storage: Storage) 
  {
      this.filterType = "asc";
      this.radioFolderArr = [];
      this.assets = [];
      this.favorites = [];
      this.currentFavoriteId = null;
      this.selectMode = false;
      this.selectedAssets = [];
  }

  ionViewDidLoad() {
    this.getAssets();
    this.getFavoritesInStorage();
    this.getDisplayListView();
  }

  getAssets(){
    this.assetService.getAssets().then(assets => {
      this.assets = this.filterAssetsByFavorite(assets);
    });
  }

  getDisplayListView(){
    this.storage.get("displayAsList").then(displayListView => {
      if(displayListView !== null){
        this.displayAsList = displayListView;
      } else {
        this.displayAsList = false;
      }
    });
  }

  updateListView(){
    this.displayAsList = !this.displayAsList;
    this.storage.set("displayAsList", this.displayAsList);
  }

  /* FILTERS */

  filterAssetsByFavorite(assets){
    if(assets && assets.length > 0){
      return assets.filter(asset => typeof(asset.IsFavorite) !== "undefined" && asset.IsFavorite == true);
    }
    return [];
  }

  /* NEW FAVORITE FOLDER */

  selectAsset(asset: Asset){
    if(this.selectedAssets.length == 0){
      this.selectedAssets.push(asset);
    } else {
      let found = this.selectedAssets.findIndex(item => item.AssetId == asset.AssetId);
      if(found == -1){
        this.selectedAssets.push(asset);
      } else {
        this.selectedAssets.splice(found, 1);
      }
    }
  }
  
  addNewFavorite(){
    this.translate.get(['FAVORITE.NEW_FOLDER_TITLE', 'FAVORITE.NEW_FOLDER_TEXT', 'GENERAL.CANCEL']).subscribe(text => {

      const newFolder = this.alertCtrl.create({
        title: text["FAVORITE.NEW_FOLDER_TITLE"],
        message: text["FAVORITE.NEW_FOLDER_TEXT"],
        inputs: [
          {
            name: 'foldername',
            placeholder: text["FAVORITE.FOLDER_NAME"]
          },
        ],
        buttons: [
          {
            text: text["GENERAL.CANCEL"],
            handler: data => {
              console.log('Cancel clicked');
            }
          },
          {
            text: 'OK',
            handler: data => {
              this.createNewFavorite(data.foldername);
            }
          }
        ]
      });
      newFolder.present();

    });
  }

  createNewFavorite(favoriteName){
    let favoriterId = this.generateID();
    let newFavorite = {
      FavoriteName: favoriteName,
      FavoriteId: favoriterId
    }
    this.favorites.push(newFavorite);
    
    this.setFavoriteInStorage();
    this.updateRadioFavoriteArr();
  }

  updateRadioFavoriteArr(){
    this.translate.get(['MENU.FAVORITES']).subscribe(text => {
      this.radioFolderArr = [];
      let inputFavorite = {};
      inputFavorite = {
        type: 'radio',
        label: text["MENU.FAVORITES"],
        value: null
      }
      this.radioFolderArr.push(inputFavorite);
      for(let i = 0; i < this.favorites.length; i++){
        let input = {
          type: 'radio',
          label: this.favorites[i].FavoriteName,
          value: this.favorites[i].FavoriteId
        };
        this.radioFolderArr.push(input);
      }
    });
  }

  /* STORAGE */

  setFavoriteInStorage(){
    this.storage.set("favorites", this.favorites);
  }

  getFavoritesInStorage(){
    this.storage.get("favorites").then( favorites => {
      if(favorites !== null && favorites.length > 0){
        this.favorites = favorites;
        this.updateRadioFavoriteArr();
      } else {
        this.favorites = [];
      }
    });
  }

  /* MANAGE FOLDERS */

  activeSelectMode(){
    this.selectMode = true;
  }

  disableSelectMode(){
    this.selectMode = false;
    this.selectedAssets = [];
  }

  pressFolder(favorite){
    this.translate.get(['FAVORITE.RENAME_MENU', 'FAVORITE.DELETE_MENU', 'GENERAL.CANCEL', 'FAVORITE.MANAGE_FOLDER']).subscribe(text => {

      const actionSheet = this.actionSheetCtrl.create({
        title: text["FAVORITE.MANAGE_FOLDER"],
        buttons: [
          {
            text: text["FAVORITE.DELETE_MENU"],
            role: 'destructive',
            handler: () => {
              this.confirmDeleteFavoriteFolder(favorite.FavoriteId);
            }
          },{
            text: text["FAVORITE.RENAME_MENU"],
            handler: () => {
              this.showRenameFolderPopup(favorite);
            }
          },{
            text: text["GENERAL.CANCEL"],
            role: 'cancel',
            handler: () => {
              console.log('Cancel clicked');
            }
          }
        ]
      });
      actionSheet.present();

    });
  }

  deleteFavorite(favoriteId){
    if(this.favorites.length > 0) {
      let found = this.favorites.findIndex(item => item.FavoriteId == favoriteId);
      if(found !== -1){
        this.removeFavoriteIdinAssets(favoriteId);
        this.favorites.splice(found, 1);
        this.updateRadioFavoriteArr();
        this.setFavoriteInStorage();
        if(this.currentFavoriteId !== null && this.currentFavoriteId == favoriteId){
          this.currentFavoriteId = null;
        }
      }
    }
  }

  confirmDeleteFavoriteFolder(favoriteId){
    this.translate.get(['FAVORITE.DELETE_TITLE', 'FAVORITE.DELETE_TEXT', 'GENERAL.CANCEL']).subscribe(text => {

      const confirm = this.alertCtrl.create({
        title: text["FAVORITE.DELETE_TITLE"],
        message: text["FAVORITE.DELETE_TEXT"],
        buttons: [
          {
            text: text["GENERAL.CANCEL"],
            handler: data => {
              console.log('Cancel clicked');
            }
          },
          {
            text: 'OK',
            handler: data => {
              this.deleteFavorite(favoriteId);
            }
          }
        ]
      });
      confirm.present();
    });
  }

  showRenameFolderPopup(favorite){
    this.translate.get(['FAVORITE.RENAME_TITLE', 'FAVORITE.RENAME_TEXT', 'FAVORITE.FOLDER_NAME', 'GENERAL.CANCEL']).subscribe(text => {

      const renameFolder = this.alertCtrl.create({
        title: text["FAVORITE.RENAME_TITLE"],
        message: text["FAVORITE.RENAME_TEXT"],
        inputs: [
          {
            name: 'favoritename',
            placeholder: text["FAVORITE.FOLDER_NAME"],
            value: favorite.FavoriteName
          },
        ],
        buttons: [
          {
            text: text["GENERAL.CANCEL"],
            handler: data => {
              console.log('Cancel clicked');
            }
          },
          {
            text: 'OK',
            handler: data => {
              favorite.FavoriteName = data.favoritename;
              this.setFavoriteInStorage();
            }
          }
        ]
      });
      renameFolder.present();

    });
  }

  generateID(){
    let id = 0;
    let folderArr = this.favorites;
    if(folderArr.length > 0){
      let lastId = folderArr[folderArr.length - 1].FavoriteId;
      id = lastId+1;
    } else {
      id = 1;
    }
   return id; 
  }

  /* MANAGE ASSETS */

  showMoveInFolderPopup(){
    this.translate.get(['FAVORITE.MOVE_FAVORITE_MENU', 'FAVORITE.MOVE_FAVORITE_TEXT', 'GENERAL.CANCEL']).subscribe(text => {

      const moveAssetInFolder = this.alertCtrl.create({
        title: text["FAVORITE.MOVE_FAVORITE_MENU"],
        message: text["FAVORITE.MOVE_FAVORITE_TEXT"],
        inputs: this.radioFolderArr,
        buttons: [
          {
            text: text["GENERAL.CANCEL"],
            handler: data => {
              console.log('Cancel clicked');
            }
          },
          {
            text: 'OK',
            handler: favoriteId => {
              this.addFavoriteIdinAsset(favoriteId);
            }
          }
        ]
      });
      moveAssetInFolder.present();

    });
  }

  showAssetsInFavorite(favoriteId){
    this.currentFavoriteId = favoriteId;
  }

  // Move assets into a folder
  addFavoriteIdinAsset(favoriteId){
    let fId = favoriteId == "" ? null : favoriteId;
    for(let asset of this.selectedAssets){
      let index = this.assets.findIndex(item => item.AssetId == asset.AssetId);
      this.assets[index].FavoriteId = fId;
    }
    this.assetService.updateAssetsInStorage();
    this.selectMode = false;
    this.selectedAssets = [];
  }

  removeFavoriteIdinAssets(favoriteId){
    if(this.assets && this.assets.length > 0) {
      for(let i = 0; i < this.assets.length; i++){
          let asset = this.assets[i];
          if(asset.FavoriteId == favoriteId){
            asset.FavoriteId = null;
            asset.IsFavorite = false;
          }
      }
      this.assetService.updateAssetsInStorage();
      this.getAssets();
    }
  }

  setActiveClass(favorite){
    if(this.currentFavoriteId && (this.currentFavoriteId == favorite.FavoriteId)){
      return true;
    }
    return false;
  }

  activeSelectedAssets(asset){
    let found = this.selectedAssets.findIndex(item => item.AssetId == asset.AssetId);
    if(found !== -1){
      return true;
    }
    return false;
  }

  updateFilter(value){
    this.filterType = value;
  }

  removeFromFavorites(){
    if(this.selectedAssets.length > 0){
      for(let asset of this.selectedAssets){
        if(asset.IsFavorite){
          this.assetService.removeAssetInFavorite(asset);
        } 
      }
      this.getAssets();
      this.selectMode = false;
      this.selectedAssets = [];
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/favorites/favorites.ts